import { type FunctionalComponent, h } from '@stencil/core';
import type { labelProviderInterface } from '../../../../../../LabelProviderInterface';

export interface ProduktnetSection {
  labelProvider: labelProviderInterface;
  produktnetUrl: string;
  produktnetClickHandler?: Function;
  size?: string;
}

export const ProduktnetSection: FunctionalComponent<ProduktnetSection> = (
  props,
) => {
    const { labelProvider, produktnetUrl, size } = props;

    return (
      Boolean(produktnetUrl) && (
        <div class="sidepanel-produktnet produktnet-section">
          <section class="produktnet-section-cta">
            <qds-button
              importance="standard"
              size={size || 'standard'}
              icon-name="rectangle-location-pin"
              icon-library="default"
              text={labelProvider(
                'result.product.find-reseller',
                'Find a reseller',
              )}
              data-card-area="produktnet_link"
              href={produktnetUrl}
              target="_blank"
              onClick={(e) => props.produktnetClickHandler ? props.produktnetClickHandler(e) : void 0}
              class="produktnet-section-cta__button"
            ></qds-button>
          </section>
        </div>
      )
    );
};
